import { Col, Form, TimePicker } from 'antd';
import type { IField } from '../data';
import styles from '../styles.less';

const { Item } = Form;

const Timepicker: React.FC<IField> = (props) => {
    const { name, span = 8, label, rules, placeholder, disabled, onChange, disabledDate, xs, lg, marginBottom = 0, inputReadOnly, t } = props;

    const grid = {
        xs: xs || span,
        lg: lg || span,
        span: span,
    };

    const styling = {
        style: marginBottom ? { marginBottom } : {},
    };

    return (
        <Col key={name} {...grid}>
            <Item label={t?.(label)} name={name} rules={rules} {...styling}>
                <TimePicker placeholder={t?.(placeholder)} disabled={disabled} className={styles.fullWidth} disabledDate={disabledDate} inputReadOnly={inputReadOnly} onChange={onChange} />
            </Item>
        </Col>
    );
};

export default Timepicker;
